// removed by extract-text-webpack-plugin
module.exports = {"menu":"Menu-m__menu___2Ajh3","menuMobile":"Menu-m__menuMobile___2_nxz","menuContent":"Menu-m__menuContent___3A39j","menuItem":"Menu-m__menuItem___3YCXe","menuTitle":"Menu-m__menuTitle___37eMy","menuTrigger":"Menu-m__menuTrigger___2CcJ3","menuItemActive":"Menu-m__menuItemActive___2YRqi","menuTriggerActive":"Menu-m__menuTriggerActive___7rCEE","menuItemHasChildren":"Menu-m__menuItemHasChildren___1CKr9","menuItemOpened":"Menu-m__menuItemOpened___3FjXR"};


//////////////////
// WEBPACK FOOTER
// ./components/menu/Menu.m.sass
// module id = GFve
// module chunks = 0